import { GET_SURVEYS } from './actions';

const initialState = {
  isLoading: false,
  data: {},
  error: null,
};

export default function surveys(state = initialState, action) {
  switch (action.type) {
    case GET_SURVEYS:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case `${GET_SURVEYS}_SUCCESS`:
      return {
        isLoading: false,
        data: action.data,
        error: null,
      };
    case `${GET_SURVEYS}_ERROR`:
      return {
        isLoading: false,
        data: initialState.data,
        error: action.error.message,
      };
    default:
      return state;
  }
}
